var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"setting.working-activity.label","bread-crumb-data":_vm.breadCrumbData}},[_c('working-activities-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }